import React, {Component, Fragment, useEffect, useState} from "react";

import { useHistory , useLocation } from "react-router";


import Select from 'react-select'
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import Breadcrumb from "../../common/breadcrumb";
import "./index.css";

// ../../../../images/candidate/upload.png 
//  download fill

import Upload from "../../../images/candidate/download.svg";
import {
    TabContent,
    TabPane,
    Nav,
    NavItem,
    NavLink,
    Row,
    Col,
    Button,
    Label,
    Form,
    FormGroup,
    FormFeedback,
    Input,
    FormText,
    Card,
    CardBody,
    CardHeader,
    Collapse
} from "reactstrap";

import pdf from "../images/document.svg";

// reducer and contex

import {  useProfilecontext } from "./Editprofileprovider";



// 
import ProfilePanel from './component/ProfileTab'
import DocumentPanel from './component/DocumentTab'
import ReferencePanel from "./component/ReferenceTab";
import HealthQuestionPanel from "./component/HealthQuestionTab";
import PaymentDetailPanel from "./component/PaymentDetailsTab";
import request from "../../../api/api";
import { toast } from "react-toastify";
import { initailState } from "./utils/profileReducer";
import { CheckValue  , IsBoolean , IsArray , StringToBoolean } from "../../common/utils";






// ------------------------------ for some basic styles -=---------------------------------------

const cursor_pointer = { cursor: "pointer" };











// react select 


const options = [
    { value: 'chocolate', label: 'Chocolate' },
    { value: 'strawberry', label: 'Strawberry' },
    { value: 'vanilla', label: 'Vanilla' }
  ]

  const customStyles = {
    control: (base) => ({
        ...base,
        minHeight:"50px"
    }),
    menu: (base) => ({
        ...base,
        marginLeft: "0px", marginTop: "0px", fontSize: "14px", zIndex:9
    }),
    placeholder: (base) => ({
      ...base,
      fontSize:"14px"
    }),
    input: (defaultStyles) => {
        return {
            ...defaultStyles,
            padding: "0 22px",
            color: "#343434",
            outline: "none",
        }
    },
    
}

const customSize = {
  control: (base) => ({
      ...base,
      minHeight:"50px",
      fontSize:"14px"
  }),
  menu: (base) => ({
      ...base,
      marginLeft: "0px", marginTop: "0px", fontSize: "14px", zIndex:9
  }),
  placeholder: (base) => ({
    ...base,
    fontSize:"14px"
  }),
  input: (defaultStyles) => {
      return {
          ...defaultStyles,
          padding: "0 22px",
          color: "#343434",
          outline: "none",
          fontSize:"14px"
      }
  },
  
}



function EditProfile() {

    const [ {  activeTab , toastdata} ,dispatch ] = useProfilecontext()

    const IsActiveTab = (tab = 'menu', tabId = '') => (activeTab[tab] === tabId);


    //  location and history 
    const domhistory = useHistory();
    const domLocation = useLocation();



    // reducers  state 
    const SET_STATE = (payload ={})=>{
        dispatch({type:"SET_STATE" , payload})
    }







    // To get the emmploye profile and set to the reducer stat
    

    async function getEmployeeProfile(){
        const payload = initailState || {};
        // const payload = {};
    try {
        const res = await request({url: "/employee/profile",method: "POST"})
        // console.log(res , "res--")
            if(res.status === 1){

                const res_result = res.response.result ? res.response.result : {};
                const form_data = res_result.onlineform ? res_result.onlineform : {};
                const form_personaldetails = (form_data && form_data.personaldetails )? form_data.personaldetails : {};
                const form_aboutwork = form_data && form_data.aboutyourwork ? form_data.aboutyourwork : {},
                      form_abletowork = form_aboutwork.abletowork ? form_aboutwork.abletowork : {}

                payload.userid = res_result._id || "";

                payload.total_percentage = res.response && res_result && res_result.total_percentage ? res_result.total_percentage : 0;
                payload.remaining_percentage = res.response && res_result && res_result.remaining_percentage ? res_result.remaining_percentage : 0;

                payload.review_ok_submit = Boolean(res.response && res_result && res_result.total_percentage && res_result.total_percentage <= 95);

                payload.addtionalFieldsValue = IsArray(form_data.addtionalFields) ? form_data.addtionalFields : []



                // Personal details 1

                payload.title = form_personaldetails.title;
                payload.firstname = res_result.name;
                payload.prefferedName = form_personaldetails.prefferedName;
                payload.middlename = form_personaldetails.middlename;
                payload.lastname = res_result.surname;
                payload.maidenName = form_personaldetails.maidenName;
                payload.isNameChanged = form_personaldetails.isNameChanged;
                payload.previousName = form_personaldetails.previousName;
                payload.gender = form_personaldetails.gender;
                payload.joining_date = res_result.joining_date && CheckValue(res_result.joining_date) ? res_result.joining_date : "";
                payload.empBio = res && CheckValue(res_result.empBio) ? res_result.empBio : "";
                payload.UploadIDPhoto = form_data.UploadIDPhoto;


                // Personal details 1
                payload.dateofbirth = form_personaldetails.dateofbirth;
                payload.martialStatus = form_personaldetails.martialStatus;
                payload.insuranceno = form_personaldetails.insuranceno;
                payload.nationality = form_personaldetails.nationality
                payload.religion = form_personaldetails.religion;
                
                
                // CONTACT AND ADDRESS DETAILS

                payload.mobileno = form_personaldetails.mobileno || "";
                payload.email = res_result.email || '';
                payload.homephone = form_personaldetails.homephone || "";
                payload.streetAddress = form_personaldetails.address && form_personaldetails.address.streetAddress ? form_personaldetails.address.streetAddress : "";
                payload.addressline2 = form_personaldetails.address && form_personaldetails.address.addressline2 ? form_personaldetails.address.addressline2 : "";
                payload.city = form_personaldetails.address && form_personaldetails.address.city ? form_personaldetails.address.city : "";
                payload.state = form_personaldetails.address && form_personaldetails.address.state ? form_personaldetails.address.state : "";
                payload.zip = form_personaldetails.address && form_personaldetails.address.zip ? form_personaldetails.address.zip : "";
                payload.country = form_personaldetails.address && form_personaldetails.address.country ? form_personaldetails.address.country : "";
                payload.dateMovedAddress = form_personaldetails && form_personaldetails.dateMovedAddress ? form_personaldetails.dateMovedAddress : "";
                payload.uploadAddressProof = IsArray(form_data.uploadAddressProof) ? form_data.uploadAddressProof : [];




                //  Work & Personal Details
                payload.workstatus = form_data.workstatus;
                payload.locations = res_result ? res_result.locations : [];
                payload.job_type = res_result ? res_result.job_type : [];


                // General Availability

                payload.work_mornings = StringToBoolean(form_abletowork.work_mornings)
                payload.work_evenings =   StringToBoolean(form_abletowork.work_evenings)
                payload.work_afternoons = StringToBoolean(form_abletowork.work_afternoons)
                payload.work_occasional = StringToBoolean(form_abletowork.work_occasional)
                payload.work_parttime = StringToBoolean(form_abletowork.work_parttime)
                payload.work_fulltime = StringToBoolean(form_abletowork.work_fulltime)
                payload.work_nights = StringToBoolean(form_abletowork.work_nights)
                payload.work_weekends = StringToBoolean(form_abletowork.work_weekends)
                payload.work_anytime = StringToBoolean(form_abletowork.work_anytime)

                payload.availablestartdate = form_aboutwork.availablestartdate;
                payload.shortnotice = form_aboutwork.shortnotice;
                payload.reduceworkflexibility = form_aboutwork.reduceworkflexibility;
                payload.workstate = form_aboutwork.workstate;

                

                // ID & Right to Work

                let docType_info = form_data.docType_info || {};

                payload.docType = form_data.docType;
                payload.docType_info = {};
                payload.docType_info.doc_type = docType_info.doc_type || '';
                payload.docType_info.doc_url =  IsArray(docType_info.doc_url) ? docType_info.doc_url: [];
                payload.docType_info.doc_no = docType_info.doc_no || '' ;
                payload.docType_info.country_issue = docType_info.country_issue ||  "";
                payload.docType_info.expiry_date = docType_info.expiry_date ||  "";
                payload.docType_info.country_issue_arr =  [];
                payload.docType_info.isvisible = IsBoolean(docType_info.isvisible) ? docType_info.isvisible : true;

                let rightToWorkType_info = form_data.rightToWorkType_info || {};

                payload.rightToWorkType = form_data.rightToWorkType;
                payload.rightToWorkType_info = {};
                payload.rightToWorkType_info.doc_type = rightToWorkType_info.doc_type || '';
                payload.rightToWorkType_info.doc_url = rightToWorkType_info.doc_url ? rightToWorkType_info.doc_url: '';
                payload.rightToWorkType_info.doc_no = rightToWorkType_info.doc_no || '' ;
                payload.rightToWorkType_info.country_issue = rightToWorkType_info.country_issue ||  "";
                payload.rightToWorkType_info.expiry_date = rightToWorkType_info.expiry_date ||  "";
                payload.rightToWorkType_info.country_issue_arr =  [];
                payload.rightToWorkType_info.share_code = rightToWorkType_info.share_code ? rightToWorkType_info.share_code : '';
                payload.rightToWorkType_info.isvisible = IsBoolean(rightToWorkType_info.isvisible) ? rightToWorkType_info.isvisible : true;
                

                // Driving License Details 
                const form_driving = form_data && form_data.drivingdetails ? form_data.drivingdetails : {};
                payload.drivinglicence = form_driving.drivinglicence || "";
                payload.drivinglicenceno = (res_result && res_result.drivers_licence && res_result.drivers_licence.licence_number) ? res_result.drivers_licence.licence_number : "";
                payload.drivinglicenceisVisible = res_result && res_result.drivers_licence && res_result.drivers_licence.licenceisVisible ? res_result.drivers_licence.licenceisVisible : false;
                payload.drivingCountryOfIssue = res_result.drivers_licence && res_result.drivers_licence.country_of_issue ? res_result.drivers_licence.country_of_issue : "";
                payload.licenceExpiry = res_result && res_result.drivers_licence && res_result.drivers_licence.licence_expiry ? res_result.drivers_licence.licence_expiry : "";
                payload.licenceClass = res_result && res_result.drivers_licence && res_result.drivers_licence.licence_class ? res_result.drivers_licence.licence_class : "";
                payload.caraccess = form_driving.caraccess || "";
                payload.bannedfromdriving = form_driving.bannedfromdriving || "";
                payload.uploaddriving = IsArray(form_data.uploaddriving) ? form_data.uploaddriving : [];



                //LanguageDetails 
                const lang =  form_data.langauages || {};
                payload.englishspoken = lang.englishspoken || "";
                payload.englishwritten = lang.englishwritten || "";
                payload.otherlanguage = lang.otherlanguage || "";
                payload.IELTStest = lang.IELTStest || "";


                // DBS DETAILS

                payload.currentDBS =  form_personaldetails.iscurrentDBS;
                payload.dbsIssueDate =  form_personaldetails.dbsIssueDate ? form_personaldetails.dbsIssueDate : '' ;
                payload.dbsExpirydate =  CheckValue(form_personaldetails.dbsExpirydate) ? form_personaldetails.dbsExpirydate : "";
                payload.dbsCertificateNo =  form_personaldetails.dbsCertificateNo;
                payload.dbsisVisible =  IsBoolean(form_personaldetails.dbsisVisible) ? form_personaldetails.dbsisVisible : true;
                payload.uploaddbs = IsArray(form_data.uploaddbs) ? form_data.uploaddbs : [];


                // NEXT OF KIN/EMERGENCY CONTACT
                const form_kin = form_data && form_data.nextofkindetails ? form_data.nextofkindetails : {};
                
                payload.kinfirstname = form_kin.kinfirstname || "";
                payload.kinlastname = form_kin.kinlastname || "";
                payload.kinrelationship = form_kin.kinrelationship || "";
                payload.kinhomephone = form_kin.kinhomephone || "";
                payload.kinemail = form_kin.kinemail || "";
                payload.kinmobileno = {}
                payload.kinmobileno.code = form_kin.kinmobileno.code
                payload.kinmobileno.dailcountry = form_kin.kinmobileno.dailcountry;
                payload.kinmobileno.number = form_kin.kinmobileno.number;

                // Address for kin/EC
                payload.save_as_my_current = IsBoolean(res_result.save_as_my_current) ? res_result.save_as_my_current : false;
                payload.kinstreetAddress = form_kin.Address.kinstreetAddress || "";
                payload.kinaddressline2 = form_kin.Address.kinaddressline2 || "";
                payload.kincity = form_kin.Address.kincity || "";
                payload.kinstate = form_kin.Address.kinstate || "";
                payload.kinzip = form_kin.Address.kinzip || "";
                payload.kincountry = form_kin.Address.kincountry || "";




                // Employment & Education

                // education_qualification

                payload.education_qualification = IsArray(res_result.education_qualification) ? res_result.education_qualification : [];
                payload.training_other_courses = IsArray(res_result.other_courses) ? res_result.other_courses : [];
                payload.professional_Body = IsArray(form_data.professional_Body) ? form_data.professional_Body : [];
                



                // Skills & Work History

                payload.work_experience = IsArray(res_result.work_exp) ? res_result.work_exp : [];
                payload.skillProvideDetails = form_data.skillProvideDetails || "";
                payload.languages = IsArray(res_result.languages) ? res_result.languages : []; 
                payload.skills = IsArray(res_result.skills) ? res_result.skills : []; 


                //  WORKING TIME REGULATIONS *  tab sub menu 
                payload.workTimeDate = (form_data && form_data.worktimedirectives) ?  form_data.worktimedirectives.date : new Date();
                payload.workTimeSignature = (form_data && form_data.worktimedirectives) ?( form_data.worktimedirectives.signature || "") : "";


                // HEALTH DECLARATION
                payload.acceptHealthDeclaration  = (form_data && form_data.healthDeclarationTerms) ? (StringToBoolean(form_data.healthDeclarationTerms.acceptHealthDeclaration) || false) : "";
                payload.HealthDeclarationDate  = (form_data && form_data.healthDeclarationTerms) ? (form_data.healthDeclarationTerms.date || "") : new Date();


                // PERSONAL DECLARATION
                payload.acceptPersonalDeclaration = form_data.personalDeclarationTerms ? StringToBoolean(form_data.personalDeclarationTerms.acceptPersonalDeclaration) : "" ;
                payload.PersonalDeclarationDate = form_data.personalDeclarationTerms ? form_data.personalDeclarationTerms.date : new Date() ;

                // CONFIDENTIALITY
                payload.ConfidentialityDate = form_data.confidentialityTerms ? form_data.confidentialityTerms.date : "" ;
                payload.acceptConfidentiality = form_data.confidentialityTerms ? StringToBoolean(form_data.confidentialityTerms.acceptConfidentiality) : "" ;

                // REHABILITATION OF OFFENDERS ACT 1974 & CRIMINAL RECORDS
                payload.criminaloffence = (form_data.criminal_records && form_data.criminal_records.criminaloffence) || "";
                payload.criminalCautioned = form_data.criminal_records ? form_data.criminal_records.criminalCautioned : "" ;
                payload.criminalConvictions = form_data.criminal_records ? form_data.criminal_records.criminalConvictions : "" ;
                payload.criminalCourt = form_data.criminal_records ? form_data.criminal_records.criminalCourt : "" ;
                payload.criminalDisciplinaryAction = form_data.criminal_records ? form_data.criminal_records.criminalDisciplinaryAction : "" ;
                payload.criminalAdditionalInformation = form_data.criminal_records ? form_data.criminal_records.criminalAdditionalInformation : "" ;


                // "Disclosure Barring Service (DBS)

                payload.dbsAccept = form_data.dbsDeclaration ? StringToBoolean(form_data.dbsDeclaration.dbsAccept)  : "" ;
                payload.dbsAcceptDate = form_data.dbsDeclaration ? form_data.dbsDeclaration.date  : "" ;


                 
                // DISABILITY & DISCRIMINATION ACT 1985
                payload.registereddisabled = form_data.disable_act ? form_data.disable_act.registereddisabled : '';
                 // if registereddisabled equals yes
                payload.disableRegisteredDetails = form_data.disable_act ? form_data.disable_act.disableRegisteredDetails : ''  ;

                payload.disableAct = form_data.disable_act ? form_data.disable_act.disableAct : ''  ;
                // if disableAct equals yes
                payload.disableActDetails = form_data.disable_act ? form_data.disable_act.disableActDetails : ''  ;

                payload.disableOverCome = form_data.disable_act ? form_data.disable_act.disableOverCome : ''  ;
                // if disableOverCome equal yes
                payload.disableOverComeDetails  = form_data.disable_act ? form_data.disable_act.disableOverComeDetails : ''  ;


                // APPLICATION FORM DECLARATION
                payload.declarationAccept = form_data.declaration ? StringToBoolean(form_data.declaration.declarationAccept) : ""  ;
                payload.declarationAcceptDate = form_data.declaration ? form_data.declaration.declarationAcceptDate : ""  ;
                payload.signature = res_result ? res_result.signature : ""  ;
                

                // OTHER DOCUMENTS

                payload.other_documents = IsArray(res_result.documents)  ? res_result.documents : [];

                // REFERENCES
                
                // Reference 1
                payload.firstrefisvisible = (form_data.reference1 && IsBoolean(form_data.reference1.firstrefisvisible)) ? form_data.reference1.firstrefisvisible : true ;
                payload.firstrefrelationship = form_data.reference1 ? form_data.reference1.firstrefrelationship : "" ;
                payload.firstreffirstname = form_data.reference1 ? form_data.reference1.firstreffirstname : "" ;
                payload.firstreflastname = form_data.reference1 ? form_data.reference1.firstreflastname : "" ;
                payload.firstrefphone = {};
                payload.firstrefphone.number = form_data.reference1 ? (form_data.reference1.firstrefphone && form_data.reference1.firstrefphone.number) : "" ;
                payload.firstrefphone.code = form_data.reference1 ? (form_data.reference1.firstrefphone && form_data.reference1.firstrefphone.code) : "" ;
                payload.firstrefphone.dialcountry = form_data.reference1 ? (form_data.reference1.firstrefphone && form_data.reference1.firstrefphone.dailcountry) : "" ;
                payload.firstrefemail = form_data.reference1 ? form_data.reference1.firstrefemail : "" ;
                payload.firstrefconfirmemail = form_data.reference1 ? form_data.reference1.firstrefconfirmemail : "" ;
                payload.firstref_address = {};
                payload.firstref_address.firstrefstreetAddress = form_data.reference1 ? (form_data.reference1.Address && form_data.reference1.Address.firstrefstreetAddress) : "" ;
                payload.firstref_address.firstrefcity = form_data.reference1 ? (form_data.reference1.Address && form_data.reference1.Address.firstrefcity) : "" ;
                payload.firstref_address.firstrefstate = form_data.reference1 ? (form_data.reference1.Address && form_data.reference1.Address.firstrefstate) : "" ;
                payload.firstref_address.firstrefzip = form_data.reference1 ? (form_data.reference1.Address && form_data.reference1.Address.firstrefzip) : "" ;

                // Reference 2
                payload.secondrefisvisible = (form_data.reference1 && IsBoolean(form_data.reference1.secondrefisvisible)) ? form_data.reference1.secondrefisvisible : true ;
                payload.secondrefrelationship = form_data.reference2 ? form_data.reference2.secondrefrelationship : "" ;
                payload.secondreffirstname = form_data.reference2 ? form_data.reference2.secondreffirstname : "" ;
                payload.secondreflastname = form_data.reference2 ? form_data.reference2.secondreflastname : "" ;
                payload.secondrefphone = {};
                payload.secondrefphone.number = form_data.reference2 ? (form_data.reference2.secondrefphone && form_data.reference2.secondrefphone.number) : "" ;
                payload.secondrefphone.code = form_data.reference2 ? (form_data.reference2.secondrefphone && form_data.reference2.secondrefphone.code) : "" ;
                payload.secondrefphone.dialcountry = form_data.reference2 ? (form_data.reference2.secondrefphone && form_data.reference2.secondrefphone.dailcountry) : "" ;
                payload.secondrefemail = form_data.reference2 ? form_data.reference2.secondrefemail : "" ;
                payload.secondrefconfirmemail = form_data.reference2 ? form_data.reference2.secondrefconfirmemail : "" ;
                payload.secondref_address = {};
                payload.secondref_address.secondrefstreetAddress = form_data.reference2 ? (form_data.reference2.Address && form_data.reference2.Address.secondrefstreetAddress) : "" ;
                payload.secondref_address.secondrefcity = form_data.reference2 ? (form_data.reference2.Address && form_data.reference2.Address.secondrefcity) : "" ;
                payload.secondref_address.secondrefstate = form_data.reference2 ? (form_data.reference2.Address && form_data.reference2.Address.secondrefstate) : "" ;
                payload.secondref_address.secondrefzip = form_data.reference2 ? (form_data.reference2.Address && form_data.reference2.Address.secondrefzip) : "" ;

                // Reference 3
                payload.thirdrefisvisible = (form_data.reference3 && IsBoolean(form_data.reference3.thirdrefisvisible)) ? form_data.reference3.thirdrefisvisible : true ;
                payload.thirdrefrelationship = form_data.reference3 ? form_data.reference3.thirdrefrelationship : "" ;
                payload.thirdreffirstname = form_data.reference3 ? form_data.reference3.thirdreffirstname : "" ;
                payload.thirdreflastname = form_data.reference3 ? form_data.reference3.thirdreflastname : "" ;
                payload.thirdrefphone = {};
                payload.thirdrefphone.number = form_data.reference3 ? (form_data.reference3.thirdrefphone && form_data.reference3.thirdrefphone.number) : "" ;
                payload.thirdrefphone.code = form_data.reference3 ? (form_data.reference3.thirdrefphone && form_data.reference3.thirdrefphone.code) : "" ;
                payload.thirdrefphone.dialcountry = form_data.reference3 ? (form_data.reference3.thirdrefphone && form_data.reference3.thirdrefphone.dailcountry) : "" ;
                payload.thirdrefemail = form_data.reference3 ? form_data.reference3.thirdrefemail : "" ;
                payload.thirdrefconfirmemail = form_data.reference3 ? form_data.reference3.thirdrefconfirmemail : "" ;
                payload.thirdref_address = {};
                payload.thirdref_address.thirdrefstreetAddress = form_data.reference3 ? (form_data.reference3.Address && form_data.reference3.Address.thirdrefstreetAddress) : "" ;
                payload.thirdref_address.thirdrefcity = form_data.reference3 ? (form_data.reference3.Address && form_data.reference3.Address.thirdrefcity) : "" ;
                payload.thirdref_address.thirdrefstate = form_data.reference3 ? (form_data.reference3.Address && form_data.reference3.Address.thirdrefstate) : "" ;
                payload.thirdref_address.thirdrefzip = form_data.reference3 ? (form_data.reference3.Address && form_data.reference3.Address.thirdrefzip) : "" ;


                // Health Questionnaire

                payload.sufferedlongtermillness =  (form_data.healthdeclaration && form_data.healthdeclaration.sufferedlongtermillness) ||  "";
                //  if yes sufferedlongtermillness
                payload.sufferedlongtermillness_notes =  (form_data.healthdeclaration && form_data.healthdeclaration.sufferedlongtermillness_notes) ||  "";

                payload.leaveforneckinjury =  (form_data.healthdeclaration && form_data.healthdeclaration.leaveforneckinjury) ||  "";
                // if yes leaveforneckinjury
                payload.leaveforneckinjury_notes =  (form_data.healthdeclaration && form_data.healthdeclaration.leaveforneckinjury_notes) ||  "";

                payload.neckinjuries =  (form_data.healthdeclaration && form_data.healthdeclaration.neckinjuries) ||  "";
                // if yes neckinjuries
                payload.neckinjuries_notes =  (form_data.healthdeclaration && form_data.healthdeclaration.neckinjuries_notes) ||  "";
                
                payload.sixweeksillness =  (form_data.healthdeclaration && form_data.healthdeclaration.sixweeksillness) ||  "";
                // if yes sixweeksillness
                payload.sixweeksillness_notes =  (form_data.healthdeclaration && form_data.healthdeclaration.sixweeksillness_notes) ||  "";
                
                payload.communicabledisease =  (form_data.healthdeclaration && form_data.healthdeclaration.communicabledisease) ||  "";
                // if yes communicabledisease
                payload.communicabledisease_notes =  (form_data.healthdeclaration && form_data.healthdeclaration.communicabledisease_notes) ||  "";

                payload.medicalattention =  (form_data.healthdeclaration && form_data.healthdeclaration.medicalattention) ||  "";
                // if yes medicalattention
                payload.healthdeclarationdetails =  (form_data.healthdeclaration && form_data.healthdeclaration.healthdeclarationdetails) ||  "";

                payload.absentfromwork =  (form_data.healthdeclaration && form_data.healthdeclaration.absentfromwork) ||  "";


                // Medical History 2
                
                payload.medicalillness = (form_data.medicalhistory && form_data.medicalhistory.medicalillness) || "" ;
                // if yes medicalillness
                payload.medicalillness_notes = (form_data.medicalhistory && form_data.medicalhistory.medicalillness_notes) || "" ;
                
                payload.medicalillnesscaused = (form_data.medicalhistory && form_data.medicalhistory.medicalillnesscaused) || "" ;
                // if yes medicalillnesscaused
                payload.medicalillnesscaused_notes = (form_data.medicalhistory && form_data.medicalhistory.medicalillnesscaused_notes) || "" ;
                
                payload.treatment = (form_data.medicalhistory && form_data.medicalhistory.treatment) || "" ;
                // if yes treatment
                payload.treatment_notes = (form_data.medicalhistory && form_data.medicalhistory.treatment_notes) || "" ;
                
                payload.needanyadjustments = (form_data.medicalhistory && form_data.medicalhistory.needanyadjustments) || "" ;
                // if yes needanyadjustments
                payload.needanyadjustmentsnotes = (form_data.medicalhistory && form_data.medicalhistory.needanyadjustmentsnotes) || "" ;

                // TUBERCULOSIS
                    
                payload.livedUK = (form_data.tuberculosis && form_data.tuberculosis.livedUK) || "";
                // if no livedUK
                payload.livedUKnotes = (form_data.tuberculosis && form_data.tuberculosis.livedUKnotes) || "";
                    
                payload.BCGvaccination = (form_data.tuberculosis && form_data.tuberculosis.BCGvaccination) || "";
                payload.cough = (form_data.tuberculosis && form_data.tuberculosis.cough) || "";
                payload.weightloss = (form_data.tuberculosis && form_data.tuberculosis.weightloss) || "";
                payload.fever = (form_data.tuberculosis && form_data.tuberculosis.fever) || "";
                payload.TB = (form_data.tuberculosis && form_data.tuberculosis.TB) || "";

                // MEDICAL HISTORY ---> yes or no questions
                payload.heartCirculatory = (form_data.immunisationhistory && form_data.immunisationhistory.heartCirculatory) ||  "" ;
                payload.diabetes = (form_data.immunisationhistory && form_data.immunisationhistory.diabetes) ||  "" ;
                payload.asthma = (form_data.immunisationhistory && form_data.immunisationhistory.asthma) ||  "" ;
                payload.bronchitis = (form_data.immunisationhistory && form_data.immunisationhistory.bronchitis) ||  "" ;
                payload.epilepsy = (form_data.immunisationhistory && form_data.immunisationhistory.epilepsy) ||  "" ;
                payload.headaches = (form_data.immunisationhistory && form_data.immunisationhistory.headaches) ||  "" ;
                payload.psychiatric = (form_data.immunisationhistory && form_data.immunisationhistory.psychiatric) ||  "" ;
                payload.dermatitis = (form_data.immunisationhistory && form_data.immunisationhistory.dermatitis) ||  "" ;
                payload.backProblems = (form_data.immunisationhistory && form_data.immunisationhistory.backProblems) ||  "" ;
                payload.recurrentInfections = (form_data.immunisationhistory && form_data.immunisationhistory.recurrentInfections) ||  "" ;
                payload.hepatitis = (form_data.immunisationhistory && form_data.immunisationhistory.hepatitis) ||  "" ;
                payload.chickenpox = (form_data.immunisationhistory && form_data.immunisationhistory.chickenpox) ||  "" ;
                
                // COVID vaccination History
                payload.covidVaccination = res_result.covidVaccination || '';
                payload.covidVaccination_date = res_result.covidVaccination_date || "";

                // Immunisation History
                payload.varicella = (form_data.immunisationhistory && form_data.immunisationhistory.varicella) ||  "";
                payload.tuberculosis = (form_data.immunisationhistory && form_data.immunisationhistory.tuberculosis) ||  "";
                payload.heaf = (form_data.immunisationhistory && form_data.immunisationhistory.heaf) ||  "";
                payload.rubella = (form_data.immunisationhistory && form_data.immunisationhistory.rubella) ||  "";
                payload.poliomyelitis = (form_data.immunisationhistory && form_data.immunisationhistory.poliomyelitis) ||  "";
                payload.hepatitisB = (form_data.immunisationhistory && form_data.immunisationhistory.hepatitisB) ||  "";
                payload.tetanus = (form_data.immunisationhistory && form_data.immunisationhistory.tetanus) ||  "";
                payload.typhoid = (form_data.immunisationhistory && form_data.immunisationhistory.typhoid) ||  "";

                // GP’s Details

                const form_gp = form_data && form_data.gpdetails ? form_data.gpdetails : {};
                payload.GPname = form_gp.GPname ||  "";
                payload.GPstreetAddress = (form_gp.gpaddress && form_gp.gpaddress.GPstreetAddress) || "";
                payload.GPcity = (form_gp.gpaddress && form_gp.gpaddress.GPcity) || "";
                payload.GPstate = (form_gp.gpaddress && form_gp.gpaddress.GPstate) || "";
                payload.GPzip = (form_gp.gpaddress && form_gp.gpaddress.GPzip) || "";
                
                payload.GPphone.dialcountry = (form_gp.GPphone && form_gp.GPphone.dialcountry)  || "";
                payload.GPphone.number = (form_gp.GPphone && form_gp.GPphone.number)  || "";
                payload.GPphone.code = (form_gp.GPphone && form_gp.GPphone.code)  || "";



                //  Payment Details
                const bankDetails = res_result.bank_details || {};
                const uniform_details = res_result.uniform_details || {};
                payload.bankName = bankDetails.bankName || "";
                payload.accountType = bankDetails.accountType || "";
                payload.accountName = bankDetails.accountName || "";
                payload.bank_sort_code = bankDetails.bank_sort_code || "";
                payload.bank_ac_name = bankDetails.bank_ac_name || "";
                payload.top_size = uniform_details.top_size || "";
                payload.agencydata = Array.isArray(res_result.agencydata) ? (res_result.agencydata[0] || {})  : {};

            


                SET_STATE(payload);


                return payload;
            }else{
                toast.error(res.response)
            }
        
    } catch (error) {
        // console.log("🚀 ~ file: index.js:412 ~ getEmployeeProfile ~ error:", error);
        toast.error(error && error.message)
    }
    }

    async function getAgencyDetails({locations = [] ,job_type =[]}){

        locations = IsArray(locations) ? locations : [];
        job_type = IsArray(job_type) ? job_type : [];

        // console.log(locations  , job_type, "locations locations")

        let payload = {}

        try {
            const res = await request({ url: "/employee/agencydetails", method: "post", })
                if(res.status === 1){
                    payload.worklist = res.response.result[0].locations || {};
                    payload.jobtypelist = res.response.result[0].jobtypes || {};
                    payload.company_name = res.response.result[0].company_name || "";

                    SET_STATE(payload);

                    if ( res.response && res.response.result.length > 0 && Array.isArray(res.response.result) && res.response.result[0].locations && res.response.result[0].locations.length > 0 && Array.isArray(res.response.result[0].jobtypes)) {
                        const worklist = res.response.result[0].locations.map(
                            (emp, key) => ({
                                value: emp._id,
                                label: emp.name,
                            })
                        );
                        let locationsValue = worklist.filter((item) => {
                            return locations.includes(item.value);
                        });
                        
                        payload = {
                            worklist,
                            locations: locationsValue,
                            locationsValue,
                        };
                        SET_STATE(payload)
                    }
                    if ( res.response && res.response.result.length > 0 && Array.isArray(res.response.result) && res.response.result[0].jobtypes && res.response.result[0].jobtypes.length > 0 && Array.isArray(res.response.result[0].jobtypes)) {
                        const jobtypelist = res.response.result[0].jobtypes.map(
                            (emp, key) => ({
                                value: emp._id,
                                label: emp.name,
                            })
                        );
                        let job_typeValue = jobtypelist.filter((item) => {
                            return job_type.includes(item.value)
                        });
    
                        payload = {
                            jobtypelist,
                            job_type: job_typeValue,
                            job_typeValue,
                        };
                        SET_STATE(payload)
                    }



                }
            
        } catch (error) {
            
        }
        
    }

    //  to get the template fields ....  /candidate/onlineform_template
    async function getTemplateFields() { 
		request({
			url: "/candidate/onlineform_template",
			method: "POST",
		}).then((results = {}) => {
			// console.log(results , "from the candidate template form .....");
			let staticFields = Array.isArray(results.response && results.response.staticFields) ? results.response.staticFields : [],
				addtionalFields = Array.isArray(results.response && results.response.addtionalFields) ? results.response.addtionalFields  : [];
			// this.setState({ templateFields: staticFields , templateAddtionalFields:addtionalFields   });
            SET_STATE({staticFields , addtionalFields})

		}).catch((error) => console.error("Error", error));
		// this.setState(()=>({templateFields:dummyFields}))
	}





    useEffect(()=>{
        let { active_accordion,active_accordion_menu='' } = (domhistory.location && domhistory.location.state) || {};

        getEmployeeProfile().then((res={})=>{
            getAgencyDetails(res)
            getTemplateFields();
            console.log( active_accordion_menu ,active_accordion,'active_accordion' )
            if(active_accordion_menu === 'references'){
                toggleTab('menu', '3')
            }
        });
    },[])


    // for handle toast 

    useEffect(()=>{
        // console.log('toast...................' , toastdata)
        if(toastdata.id && toastdata.message && toastdata.id ){
            handleToast(toastdata)
        }

    },[toastdata, toastdata.id, toastdata.message, toastdata.type])




    // Redirect function 
    const redirectToProile = (path = '/' , state = {})=> domhistory.push({
        pathname:path,
        state,
    })

    /**
     * 
     * @param {*} id 
     * @param {*} message 
     * @param {import("react-toastify").TypeOptions} type 
     */
    const handleToast = ({id = '' , message = '' , type = ""}) =>{
        toast(message , { autoClose:2500 ,type , })
    }



    // ---------- handlersss ---------------

    const toggleTab = (tab = '', tabId = '') => {
        dispatch({
            type:"TOGGLE_TAB",
            payload:{ tab , tabId }
        })
    }


    return (

        <div className="edit-profile-page">

            {/* for back to profile page */}
            <div className="back-page">
                <button style={cursor_pointer} onClick={()=>redirectToProile("/profile/viewprofile")}>
                    <i class="fa fa-arrow-left" aria-hidden="true"></i>
                </button>
                <span>Profile</span>
                <span className="current-page">Edit Profile</span>
            </div>

            <div className="profile-tab col-sm-12 col-xs-12">

                <Nav tabs className="nav-pills nav-info horz-tab">
                    
                    <NavItem 
                        className={`${IsActiveTab('menu', "1") ? "active" : ""}`}
                        role="tablist"
                        onClick={ () => toggleTab('menu', '1')}
                        disable={false}
                        >
                        <NavLink>Profile</NavLink>
                    </NavItem>

                    <p>|</p>

                    <NavItem 
                        className={`${IsActiveTab('menu', "2") ? "active" : ""}`}
                        role="tablist"
                        onClick={() => toggleTab('menu', '2')}
                        disable={false}
                        >
                        <NavLink>Documents</NavLink>
                    </NavItem>

                    <p>|</p>

                    <NavItem 
                        className={`${IsActiveTab('menu', "3") ? "active" : ""}`}
                        role="tablist"
                        onClick={() => toggleTab('menu', '3')}
                        disable={false}
                        >
                        <NavLink>References</NavLink>
                    </NavItem>

                    <p>|</p>
                    
                    <NavItem 
                        className={`${IsActiveTab('menu', "4") ? "active" : ""}`}
                        role="tablist"
                        onClick={() => toggleTab('menu', '4')}
                        disable={false}
                        >
                        <NavLink>Health Questionnaire</NavLink>
                    </NavItem>

                    <p>|</p>

                    <NavItem 
                        className={`${IsActiveTab('menu', "5") ? "active" : ""}`}
                        role="tablist"
                        onClick={() => toggleTab('menu', '5')}
                        disable={false}
                        >
                        <NavLink>Payroll Details</NavLink>
                    </NavItem>

                </Nav>
            </div>

            <div className="candidate-main">

                <Breadcrumb title="Edit Profile" parent="Profile"/>

                <div className="mar-top"></div>
                <div className="card main-space">
                    <div className="editing-candidates">

                        <div className="col-sm-12 col-xs-12">
                            <TabContent activeTab={activeTab.menu} className="myspace-functions edit_part" >


                                {/* Profile  */}
                                <TabPane tabId="1"> 
                                    <ProfilePanel isactivetab={IsActiveTab} activeTab={activeTab}  toggleTab={toggleTab}  /> 
                                </TabPane>

                                {/* Documents */}
                                <TabPane tabId="2">
                                    <DocumentPanel isactivetab={IsActiveTab} activeTab={activeTab}  toggleTab={toggleTab} />
                                </TabPane>
                                
                                {/* References */}
                                <TabPane tabId="3">
                                    <ReferencePanel active_accordionId={ ((domhistory.location && domhistory.location.state) || {}).active_accordion }/>
                                </TabPane>

                                {/* Health Questionnaire  */}
                                <TabPane tabId="4">
                                    <HealthQuestionPanel />
                                </TabPane>
                                
                                {/* Payment Details */}
                                <TabPane tabId="5">
                                    {activeTab.menu == 5 &&  <PaymentDetailPanel /> }
                                </TabPane>

                            </TabContent>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}















export default EditProfile;
